import axios from '@/plugins/axios'
import * as actionTypes from '@/store/action-types'
import { GlobalState } from '@/types'
import {
  MasterDataFreeShiftItem,
  SimpleWeekTimeModelResponse,
  PgDataResponse,
  ArbeitenDataResponse,
  MasterDataQcqShiftListResponse,
  PlanningGroupList,
  Competences,
  ShiftBreakResponse, ResponseBase, GetArbeitenResponse
} from '@/types/service-response'
import { FreeShift } from '@/model/master-data/FreeShift'
import { QcqShift } from '@/model/master-data/QcqShift'
import {
  CreateMasterDataWorkPayload,
  EditMasterDataWorkPayload,
  MasterDataFreeShiftListPayload,
  MasterDataQcqShiftListPayload
} from '@/types/payload'
import { SimpleWeekTimeModel } from '@/model/master-data/SimpleWeekTimeModel'
import { ShiftBreak } from '@/model/master-data/ShiftBreak'
import moment from 'moment'

const masterDataModule = {
  actions: {
    async [actionTypes.LOAD_MASTER_DATA_FREE_SHIFT_LIST] ({ rootState }: { rootState: GlobalState }, payload: MasterDataFreeShiftListPayload): Promise<Array<FreeShift>> {
      const response = await axios.post('/api/Shift', null, {
        params: {
          'AbtID': payload.departmentId,
          'sprache': rootState.currentUser!.uiLanguage.syzId,
        }
      })

      const data: MasterDataFreeShiftItem = response.data
      return FreeShift.createListFromResponse(data)
    },

    async [actionTypes.INSERT_MASTER_DATA_FREE_SHIFT] ({ rootState }: { rootState: GlobalState }, payload: { action: string, freeShift: FreeShift }): Promise<any> {

      let planningGroupData: Array<PgDataResponse> = []
      payload.freeShift.planningGroupData.forEach((item: any) => {
        let planningGroupItem: PgDataResponse = {
          IDShif: (item.shiftId) ? item.shiftId : '',
          Schichten_PlanungsgruppeId: (item.planningGroupId) ? item.planningGroupId : '',
          Stunden: null,
          Anzahl: item.numberOfEmployees,
          Bemerkungen: item.comment,
          Abteilungen: item.departments,
          Planungruppe: item.planningGroup,
          AbteilungenBezeichnung: item.departmentsDesignation,
          PlanungsgruppeName: item.planningGroupName,
          Offset: item.offset
        }
        planningGroupData.push(planningGroupItem)
      })

      let workData: Array<ArbeitenDataResponse> = []
      payload.freeShift.workData.forEach((item: any) => {
        let workItem: ArbeitenDataResponse = {
          IDShif: (item.shiftId) ? item.shiftId : '',
          Schichten_PlanungsgruppeId: (item.planningGroupId) ? item.planningGroupId : '',
          Schichten_QCQID: (item.qcqId) ? item.qcqId : '',
          Arbeit: item.work,
          ArbeitBezeichnungCode: item.workCode,
          Plannungsgruppe: item.planningGroup,
          alreadyinsert: null,
          Offset: item.offset
        }
        workData.push(workItem)
      })

      let shiftBreakData: ShiftBreakResponse[] = payload.freeShift.shiftBreakList.map((item: ShiftBreak) => {
        return {
          Schicht: item.shift ? item.shift : null,
          Start: item.startBreak,
          Ende: item.endBreak,
          DauerG: (moment(item.duration, 'HH:mm').hour() * 60) + moment(item.duration, 'HH:mm').minutes(),
          AbzugKapazitaet: (moment(item.deductionCapacity, 'HH:mm').hour() * 60) + moment(item.deductionCapacity, 'HH:mm').minutes(),
          Bemerkungen: item.comment
        }
      })

      const response = await axios.post('/api/Shift',
          {
            'freeshiftDetailsData': [
              {
                'ID': (payload.freeShift.id) ? payload.freeShift.id : '',
                'Code': payload.freeShift.code,
                'Bezeichnung': payload.freeShift.description,
                'TypeOfShift': 'Free Shift',
                'Start': payload.freeShift.start,
                'Ende': payload.freeShift.end,
                'Budget': payload.freeShift.budget,
                'Stunden': null,
                'Anzahl': null,
                'Bemerkungen': null,
                'Abteilungen': null,
                'Planungruppe': null,
                'AbteilungenBezeichnung': null,
                'PlanungsgruppeName': null,
                'QualitaetTotal': null,
                'Farbe': payload.freeShift.color,
                'Aktiv': payload.freeShift.isActive,
                'SchichtenPausenData': shiftBreakData
              }
            ],
            'freeshiftPGData': planningGroupData,
            'freeshiftArbeitenData': workData
          }, {
          params: {
            'action': payload.action,
            'sprache': rootState.currentUser!.uiLanguage.syzId,
            'component': 'div_Login',
            'mitarbeiter': rootState.currentUser!.id
          }
        })

      return response
    },

    async [actionTypes.INSERT_MASTER_DATA_QCQ_SHIFT] ({ rootState }: { rootState: GlobalState }, payload: { action: string, qcqShift: QcqShift }): Promise<any> {

      let planningGroupData: Array<PlanningGroupList> = []
      payload.qcqShift.planningGroupList.forEach((item: any) => {
        let planningGroupItem: PlanningGroupList = {
          IDShif: (item.shiftId) ? item.shiftId : '',
          Plg_Line: 0,
          Schichten_PlanungsgruppeId: (item.planningGroupId) ? item.planningGroupId : '',
          Stunden: null,
          Anzahl: item.numberOfEmployees,
          Bemerkungen: item.comment,
          Abteilungen: item.departments,
          Planungruppe: item.planningGroup,
          AbteilungenBezeichnung: item.departmentsDesignation,
          PlanungsgruppeName: item.planningGroupName,
          Offset: item.offset
        }
        planningGroupData.push(planningGroupItem)
      })

      let competences: Array<Competences> = []
      payload.qcqShift.competences.forEach((item: any) => {
        let competencesItem: Competences = {
          ShiftID: (item.shiftId) ? item.shiftId : '',
          ShiftPLGID: (item.planningGroupId) ? item.planningGroupId : '',
          ID: item.id,
          Competences: item.competences,
          CompetencesDescription: item.competencesDescription,
          BildungsgradID: item.educationLevelId,
          BildungsgradDescription: item.educationLevelDescription,
          BerufID: item.jobId,
          BerufDescription: item.jobDescription,
          FachrichtungID: item.specializationId,
          FachrichtungDescription: item.specializationDescription,
          DetailsID: item.detailsId,
          DetailsDescription: item.detailsDescription,
          Quality: item.quality,
          Anzahl: null,
          Stunden: null,
          Bemerkungen: item.comment,
          Abteilungen: item.departments,
          Planungruppe: item.planningGroup,
          Plg_Line: 0,
          Arbeit: item.work,
          ArbeitBezeichnungCode: item.workCode,
          Offset: item.offset,
        }
        competences.push(competencesItem)
      })

      let shiftBreakData: ShiftBreakResponse[] = payload.qcqShift.shiftBreakList.map((item: ShiftBreak) => {
        return {
          Schicht: item.shift ? item.shift : null,
          Start: item.startBreak,
          Ende: item.endBreak,
          DauerG: (moment(item.duration, 'HH:mm').hour() * 60) + moment(item.duration, 'HH:mm').minutes(),
          AbzugKapazitaet: (moment(item.deductionCapacity, 'HH:mm').hour() * 60) + moment(item.deductionCapacity, 'HH:mm').minutes(),
          Bemerkungen: item.comment
        }
      })

      const response = await axios.post('/api/Shift',
        {
          'ID': (payload.qcqShift.id) ? payload.qcqShift.id : '',
          'Code': payload.qcqShift.code,
          'Bezeichnung': payload.qcqShift.description,
          'TypeOfShift': 'QCQ Shift',
          'Start': payload.qcqShift.start,
          'Ende': payload.qcqShift.end,
          'Budget': payload.qcqShift.budget,
          'Abteilungen': planningGroupData[0].Abteilungen,
          'Planungruppe': null,
          'AbteilungenBezeichnung': planningGroupData[0].AbteilungenBezeichnung,
          'PlanungsgruppeName': null,
          'QualitaetTotal': null,
          'Farbe': payload.qcqShift.color,
          'Competences': competences,
          'PlanungruppeList': planningGroupData,
          'Aktiv': payload.qcqShift.isActive,
          'SchichtenPausenData': shiftBreakData
        }
        , {
          params: {
            'action': payload.action,
            'sprache': rootState.currentUser!.uiLanguage.syzId,
            'component': 'div_Login',
            'mitarbeiter': rootState.currentUser!.id,
            'type': ''
          }
        })
      return response
    },

    async [actionTypes.LOAD_MASTER_DATA_QCQ_SHIFT_LIST] ({ rootState }: { rootState: GlobalState }, payload: MasterDataQcqShiftListPayload): Promise<Array<QcqShift>> {
      const response = await axios.post('/api/Shift', null, {
        params: {
          'AbtID': payload.departmentId,
          'sprache': rootState.currentUser!.uiLanguage.syzId,
          'Shift': ''
        }
      })

      const data: MasterDataQcqShiftListResponse = response.data
      return QcqShift.createListFromResponse(data)
    },

    async [actionTypes.LOAD_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL_LIST] ({ rootState }: { rootState: GlobalState }, payload: { action: string }): Promise<Array<SimpleWeekTimeModel>> {
      const response = await axios.post('/api/Wochenzeitmodell', null, {
        params: {
          'action': payload.action
        }
      })

      const data: SimpleWeekTimeModelResponse = response.data

      return SimpleWeekTimeModel.createListFromResponse(data)
    },

    async [actionTypes.UPDATE_DELETE_MASTER_DATA_SIMPLE_WEEK_TIME_MODEL] ({ rootState }: { rootState: GlobalState }, payload: { action: string, timeModel: SimpleWeekTimeModel }): Promise<any> {
      const response = await axios.post('/api/Wochenzeitmodell',
        {
          'ID': payload.timeModel.id,
          'MDT_IDENT_NR': '',
          'MOD_IDENT_NR': payload.timeModel.MOD_IDENT_NR,
          'Name': payload.timeModel.name,
          'ABW_Gutschrift': payload.timeModel.ABW,
          'KAL_Gutschrift': payload.timeModel.KAL,
          'Montag': payload.timeModel.monday,
          'MontagBis': payload.timeModel.mondayTo,
          'MontagVon': payload.timeModel.mondayFrom,
          'Dienstag': payload.timeModel.tuesday,
          'DienstagBis': payload.timeModel.tuesdayTo,
          'DienstagVon': payload.timeModel.tuesdayFrom,
          'Mittwoch': payload.timeModel.wednesday,
          'MittwochBis': payload.timeModel.wednesdayTo,
          'MittwochVon': payload.timeModel.wednesdayFrom,
          'Donnerstag': payload.timeModel.thursday,
          'DonnerstagBis': payload.timeModel.thursdayTo,
          'DonnerstagVon': payload.timeModel.thursdayFrom,
          'Freitag': payload.timeModel.friday,
          'FreitagBis': payload.timeModel.fridayTo,
          'FreitagVon': payload.timeModel.fridayFrom,
          'Samstag': payload.timeModel.saturday,
          'SamstagBis': payload.timeModel.saturdayTo,
          'SamstagVon': payload.timeModel.saturdayFrom,
          'Sonntag': payload.timeModel.sunday,
          'SonntagBis': payload.timeModel.sundayTo,
          'SonntagVon': payload.timeModel.sundayFrom,
          'MIT_GRUPPE': payload.timeModel.modelType
        }, {
          params: {
            'action': payload.action,
            'value': ''
          }
        })

      return response
    },

    async [actionTypes.FETCH_MASTER_DATA_WORK_LIST] ({ rootState }: { rootState: GlobalState }): Promise<GetArbeitenResponse> {
      const response = await axios.get('/api/Arbeiten/GetAll')

      return response.data
    },

    async [actionTypes.CREATE_MASTER_DATA_WORK_LIST] ({ rootState }: { rootState: GlobalState }, payload: CreateMasterDataWorkPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Arbeiten/Create', payload)
      return response.data
    },

    async [actionTypes.EDIT_MASTER_DATA_WORK_LIST] ({ rootState }: { rootState: GlobalState }, payload: EditMasterDataWorkPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Arbeiten/Update', payload)
      return response.data
    },

    async [actionTypes.DELETE_MASTER_DATA_WORK_LIST] ({ rootState }: { rootState: GlobalState }, payload: number): Promise<ResponseBase> {
      const response = await axios.get('/api/Automatic/Do',{
          params: {
            sp: 'Arbeiten_DeleteArbeit',
            i_Arbeit: payload,
            sl: 1,
            o: 'Arbeiten'
          }
        })

      return response.data
    }
  }
}

export default masterDataModule
